module.exports = __webpack_public_path__ + "img/board4-GLX-turqoise-54-thumb.d8a5b33e.jpg";